import { useState, useEffect } from 'react';
import { Button } from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addInterest, removeInterest, setRegistrationStep } from '../store/userSlice';
import { INTEREST } from '../constants/interests';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import config from '../config';

function Step5({ setStep }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate(); // Используем хук для получения axios с токеном
  const interests = useSelector((state) => state.user.registrationData.interests);
  const [disabled, setDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (interests.length >= 5) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [interests]);

  const addOption = (optionId) => {
    if (interests.includes(optionId)) {
      dispatch(removeInterest(optionId));
    } else {
      dispatch(addInterest(optionId));
    }
  };

  const saveDataAndNext = async () => {
    if (interests.length >= 5) {
      try {
        setIsSubmitting(true);

        console.log('📤 [Step5] Обновление интересов:', interests);

        // Отправляем только интересы для обновления существующего пользователя (PUT!)
        const response = await axiosPrivate.put(config.API.USERS.UPDATE_INTERESTS, {
          interests: interests
        });

        console.log('✅ [Step5] Интересы обновлены:', response.data);

        if (response.data) {
          // Интересы сохранены — регистрация завершена: сбрасываем запомненный шаг и отправляем на paywall
          dispatch(setRegistrationStep(null));
          navigate(config.ROUTES.PAYWALL);
        }
      } catch (error) {
        console.error('❌ [Step5] Ошибка обновления интересов:', error);
        console.error('❌ [Step5] Error response:', error.response?.data);
        console.error('❌ [Step5] Error status:', error.response?.status);

        let errorMessage = 'Произошла ошибка при обновлении интересов';

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(`Ошибка: ${errorMessage}`);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      alert('Выберите минимум 5 интересов!');
    }
  };

  const options = INTEREST;

  return (
    <div className="flex flex-col items-center w-full px-4">
      <h1 className="font-raleway font-semibold mt-6 text-white text-[20px]">Добавьте ваши интересы</h1>
      <p className="font-raleway font-light mt-2 text-white text-center text-[16px]">
        Выберите не менее 5 интересов, чтобы поделиться ими с другими пользователями
      </p>
      <div className="flex flex-wrap gap-[8px] mt-[24px] mb-[100px]">
        {options.map((option, index) => (
          <button
            type="button"
            key={index}
            aria-pressed={interests.includes(option.id)}
            onClick={() => addOption(option.id)}
            className={`w-auto ${
              option.id === 'Права людей с ограниченными возможностями' ? 'text-[15px] p-2' : 'p-3 text-[18px]'
            } h-[48px] rounded-[400px] flex justify-center items-center font-light text-white cursor-pointer transition-all
              ${
                interests.includes(option.id)
                  ? 'bg-[#043939] border-[1.5px] border-[#a1f69e]'
                  : 'bg-[#022424] border-[1px] border-[#233636]'
              }`}
          >
            <span>{option.id}</span>
          </button>
        ))}
      </div>
      <div className="w-full fixed bottom-[24px] z-10 px-4">
        <Button className="w-full" onClick={saveDataAndNext} id="burtxteoic" disabled={disabled || isSubmitting}>
          {isSubmitting ? 'Отправка...' : 'Начать знакомства'}
        </Button>
      </div>
    </div>
  );
}

export default Step5;
